import { t } from "i18next";
import React from "react";

type LoadingButtonProps = {
  status: "idle" | "submitting" | "submitted";
  idleText: string;
  submittingText?: string;
  submittedText?: string;
  type?: "button" | "submit" | "reset";
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};

const LoadingButton: React.FC<LoadingButtonProps> = ({
  status,
  idleText,
  submittingText = t('feedback.loading'),
  submittedText = t('feedbak.submitted'),
  type = "button",
  className = "btn btn-primary",
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled || status !== "idle"}
    >
      {status === "submitting" && (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          {submittingText}
        </>
      )}
      {status === "submitted" && submittedText}
      {status === "idle" && idleText}
    </button>
  );
};

export default LoadingButton;
